/**
 * Wrapper for time-phased planning surfaces.
 *
 * time_phased_planning starts on and a workspace admin can switch it off
 * (owner ruling 2026-10-14: every module is default on, not required on).
 * When it is off, these surfaces leave the same way every module-gated route
 * does — through the one route guard.
 */

import type { ReactNode } from 'react';
import { ModuleRouteGuard } from '../../guards/ModuleRouteGuard';

export function TimePhasedModuleGate({ children }: { children: ReactNode }) {
  return <ModuleRouteGuard moduleKey="time_phased_planning">{children}</ModuleRouteGuard>;
}
